export interface InspectionRecord {
  id: string;
  vesselName: string;
  imoNumber: string;
  vesselType: string;
  flag: string;
  owner: string;
  manager: string;
  inspector: string;
  inspectorOrg: string;
  inspectionType: 'Full' | 'Partial';
  dateOfInspection: string;
  port: string;
  country: string;
  customerScope: string;
  status: 'Submitted' | 'Under Review' | 'Closed' | 'Draft';
  totalLsdScore: number;
  criticalFindings: number;
  severeFindings: number;
  categoriesInspected: number;
  itemsAnswered: number;
  totalItems: number;
  pscDetention: boolean;
  pscDeficiencies: number;
  classificationSociety: string;
  deadweight: number;
  completionPct: number;
}

// TODO: Replace with API call — GET /api/inspections
export const MOCK_INSPECTIONS: InspectionRecord[] = [
  {
    id: 'insp-001',
    vesselName: 'CAPE SHANGRILA',
    imoNumber: '9511454',
    vesselType: 'Bulk Carrier',
    flag: 'Marshall Islands',
    owner: 'Pacific Bulk Carriers',
    manager: 'Anglo Eastern Ship Mgmt',
    inspector: 'Song-Qing Zhang',
    inspectorOrg: 'Edu Maritime',
    inspectionType: 'Full',
    dateOfInspection: '2026-03-28',
    port: 'Qingdao',
    country: 'China',
    customerScope: 'Anglo American',
    status: 'Closed',
    totalLsdScore: 47,
    criticalFindings: 3,
    severeFindings: 8,
    categoriesInspected: 14,
    itemsAnswered: 318,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 11,
    classificationSociety: 'RINA',
    deadweight: 176189,
    completionPct: 99,
  },
  {
    id: 'insp-002',
    vesselName: 'IRON EXPLORER',
    imoNumber: '9634821',
    vesselType: 'Bulk Carrier',
    flag: 'Panama',
    owner: 'Pacific Bulk Carriers',
    manager: 'V.Ships',
    inspector: 'James Mwangi',
    inspectorOrg: 'Right Shifts',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-02',
    port: 'Port Hedland',
    country: 'Australia',
    customerScope: 'FMG',
    status: 'Under Review',
    totalLsdScore: 62,
    criticalFindings: 5,
    severeFindings: 12,
    categoriesInspected: 14,
    itemsAnswered: 310,
    totalItems: 322,
    pscDetention: true,
    pscDeficiencies: 18,
    classificationSociety: 'DNV GL',
    deadweight: 182000,
    completionPct: 96,
  },
  {
    id: 'insp-003',
    vesselName: 'VALE VITORIA',
    imoNumber: '9487293',
    vesselType: 'VLOC',
    flag: 'Liberia',
    owner: 'Oldendorff Carriers',
    manager: 'Columbia Shipmanagement',
    inspector: 'Elena Petrov',
    inspectorOrg: 'Mrs. See If Lines',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-05',
    port: 'Tubarao',
    country: 'Brazil',
    customerScope: 'Vale',
    status: 'Submitted',
    totalLsdScore: 31,
    criticalFindings: 1,
    severeFindings: 4,
    categoriesInspected: 14,
    itemsAnswered: 322,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 3,
    classificationSociety: 'Bureau Veritas',
    deadweight: 400000,
    completionPct: 100,
  },
  {
    id: 'insp-004',
    vesselName: 'CAPE ENDEAVOUR',
    imoNumber: '9601774',
    vesselType: 'Bulk Carrier',
    flag: 'Bahamas',
    owner: 'Cobelfret',
    manager: 'Bernhard Schulte',
    inspector: 'Capt. Ravi Kumar',
    inspectorOrg: 'Anglo American (Port Captain)',
    inspectionType: 'Partial',
    dateOfInspection: '2026-04-08',
    port: 'Dampier',
    country: 'Australia',
    customerScope: 'Anglo American',
    status: 'Closed',
    totalLsdScore: 12,
    criticalFindings: 0,
    severeFindings: 2,
    categoriesInspected: 1,
    itemsAnswered: 24,
    totalItems: 24,
    pscDetention: false,
    pscDeficiencies: 0,
    classificationSociety: 'Lloyd\'s Register',
    deadweight: 171000,
    completionPct: 100,
  },
  {
    id: 'insp-005',
    vesselName: 'MINERAL YANG ZI',
    imoNumber: '9723481',
    vesselType: 'Bulk Carrier',
    flag: 'Hong Kong',
    owner: 'Minerals Shipping Co.',
    manager: 'Wallem Shipmanagement',
    inspector: 'Wei Liang Chen',
    inspectorOrg: 'Edu Maritime',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-10',
    port: 'Zhoushan',
    country: 'China',
    customerScope: 'Anglo American',
    status: 'Under Review',
    totalLsdScore: 55,
    criticalFindings: 4,
    severeFindings: 9,
    categoriesInspected: 14,
    itemsAnswered: 305,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 7,
    classificationSociety: 'ClassNK',
    deadweight: 179500,
    completionPct: 95,
  },
  {
    id: 'insp-006',
    vesselName: 'RIO GRANDE BULK',
    imoNumber: '9558812',
    vesselType: 'Bulk Carrier',
    flag: 'Singapore',
    owner: 'Rio Tinto Marine',
    manager: 'Rio Tinto Ship Mgmt',
    inspector: 'Priya Nair',
    inspectorOrg: 'Right Shifts',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-12',
    port: 'Dampier',
    country: 'Australia',
    customerScope: 'Rio Tinto',
    status: 'Submitted',
    totalLsdScore: 38,
    criticalFindings: 2,
    severeFindings: 5,
    categoriesInspected: 14,
    itemsAnswered: 319,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 4,
    classificationSociety: 'ABS',
    deadweight: 165000,
    completionPct: 99,
  },
  {
    id: 'insp-007',
    vesselName: 'PACIFIC BULKER',
    imoNumber: '9412067',
    vesselType: 'Bulk Carrier',
    flag: 'Marshall Islands',
    owner: 'Zodiac Maritime',
    manager: 'Zodiac Maritime',
    inspector: 'Capt. David Osei',
    inspectorOrg: 'Anglo American (Port Captain)',
    inspectionType: 'Partial',
    dateOfInspection: '2026-04-14',
    port: 'Newcastle',
    country: 'Australia',
    customerScope: 'Anglo American',
    status: 'Closed',
    totalLsdScore: 8,
    criticalFindings: 0,
    severeFindings: 1,
    categoriesInspected: 1,
    itemsAnswered: 17,
    totalItems: 17,
    pscDetention: false,
    pscDeficiencies: 0,
    classificationSociety: 'Lloyd\'s Register',
    deadweight: 158000,
    completionPct: 100,
  },
  {
    id: 'insp-008',
    vesselName: 'CAPE ALBATROS',
    imoNumber: '9689234',
    vesselType: 'Bulk Carrier',
    flag: 'Panama',
    owner: 'Cargill Ocean Transportation',
    manager: 'Fleet Management Ltd',
    inspector: 'Tariq Al-Rashid',
    inspectorOrg: 'Mrs. See If Lines',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-15',
    port: 'Richards Bay',
    country: 'South Africa',
    customerScope: 'Anglo American',
    status: 'Submitted',
    totalLsdScore: 71,
    criticalFindings: 7,
    severeFindings: 14,
    categoriesInspected: 14,
    itemsAnswered: 298,
    totalItems: 322,
    pscDetention: true,
    pscDeficiencies: 23,
    classificationSociety: 'Bureau Veritas',
    deadweight: 177000,
    completionPct: 93,
  },
  {
    id: 'insp-009',
    vesselName: 'IRON MOUNTAIN',
    imoNumber: '9534109',
    vesselType: 'Bulk Carrier',
    flag: 'Cyprus',
    owner: 'Star Bulk Carriers',
    manager: 'Star Bulk Carriers',
    inspector: 'Olga Kovalenko',
    inspectorOrg: 'Edu Maritime',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-16',
    port: 'Port Kembla',
    country: 'Australia',
    customerScope: 'Anglo American',
    status: 'Under Review',
    totalLsdScore: 44,
    criticalFindings: 2,
    severeFindings: 7,
    categoriesInspected: 14,
    itemsAnswered: 315,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 8,
    classificationSociety: 'DNV GL',
    deadweight: 180200,
    completionPct: 98,
  },
  {
    id: 'insp-010',
    vesselName: 'MINERAL XIAMEN',
    imoNumber: '9745623',
    vesselType: 'Bulk Carrier',
    flag: 'Hong Kong',
    owner: 'COSCO Shipping',
    manager: 'COSCO Shipping Lines',
    inspector: 'Marcus Ferreira',
    inspectorOrg: 'Right Shifts',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-17',
    port: 'Itaguai',
    country: 'Brazil',
    customerScope: 'Vale',
    status: 'Submitted',
    totalLsdScore: 29,
    criticalFindings: 1,
    severeFindings: 3,
    categoriesInspected: 14,
    itemsAnswered: 320,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 2,
    classificationSociety: 'CCS',
    deadweight: 181000,
    completionPct: 99,
  },
  {
    id: 'insp-011',
    vesselName: 'CAPE NEPTUNE',
    imoNumber: '9478905',
    vesselType: 'Bulk Carrier',
    flag: 'Bahamas',
    owner: 'Pacific Bulk Carriers',
    manager: 'Anglo Eastern Ship Mgmt',
    inspector: 'Capt. Ravi Kumar',
    inspectorOrg: 'Anglo American (Port Captain)',
    inspectionType: 'Partial',
    dateOfInspection: '2026-04-18',
    port: 'Qingdao',
    country: 'China',
    customerScope: 'Anglo American',
    status: 'Draft',
    totalLsdScore: 6,
    criticalFindings: 0,
    severeFindings: 1,
    categoriesInspected: 1,
    itemsAnswered: 11,
    totalItems: 29,
    pscDetention: false,
    pscDeficiencies: 0,
    classificationSociety: 'Lloyd\'s Register',
    deadweight: 175500,
    completionPct: 38,
  },
  {
    id: 'insp-012',
    vesselName: 'VALE SOHAR',
    imoNumber: '9612834',
    vesselType: 'VLOC',
    flag: 'Liberia',
    owner: 'Oldendorff Carriers',
    manager: 'Columbia Shipmanagement',
    inspector: 'Elena Petrov',
    inspectorOrg: 'Mrs. See If Lines',
    inspectionType: 'Full',
    dateOfInspection: '2026-04-19',
    port: 'Ponta da Madeira',
    country: 'Brazil',
    customerScope: 'Vale',
    status: 'Draft',
    totalLsdScore: 18,
    criticalFindings: 0,
    severeFindings: 2,
    categoriesInspected: 6,
    itemsAnswered: 142,
    totalItems: 322,
    pscDetention: false,
    pscDeficiencies: 1,
    classificationSociety: 'Bureau Veritas',
    deadweight: 402000,
    completionPct: 44,
  },
];